import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '../components/LazyRoute'
import { SimplePageLoader } from '@/components/ui/page-loader'

export const Route = createFileRoute('/_protected/endpoints_/$id')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/pages/EndpointDetail')}
      fallback={<SimplePageLoader />}
    />
  ),
})
